<p-drawer
  [(visible)]="isActive"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  styleClass="filters-sidebar"
  [style]="{ width: '400px' }"
  (onHide)="closeFilter()">
  <ng-template pTemplate="header">
    <div class="sidebar-header">
      <div class="header-left">
        <i class="pi pi-filter"></i>
        <span class="font-bold">{{ tk.General.Filters | t }}</span>
      </div>
    </div>
  </ng-template>

  <form [formGroup]="filterForm" appAutoFormGroup>
    <div class="filter-content">
      <!-- Moeda -->
      <div class="mt-4">
        <app-select
          [allowEmptyPlaceholderSelect]="true"
          [label]="tk.Management.NdfCurrency | t"
          [placeholder]="tk.User.Select | t"
          [controlName]="'internationalCurrencyId'"
          [options]="currencyOptions">
        </app-select>
      </div>

      <!-- Banco -->
      <div class="mt-4">
        <app-select
          [allowEmptyPlaceholderSelect]="true"
          [label]="tk.Management.NdfBank | t"
          [placeholder]="tk.User.Select | t"
          [controlName]="'financialInstitutionId'"
          [options]="(financialInstitutions$ | async) || []">
          <ng-template let-item>
            <app-bank-logo
              *ngIf="item?.data?.compensationCode"
              [code]="item.data.compensationCode" />
            {{ item.label }}
          </ng-template>
        </app-select>
      </div>

      <!-- Status da Operação -->
      <div class="mt-4">
        <app-select
          [allowEmptyPlaceholderSelect]="true"
          [label]="tk.Management.NdfOperationStatus | t"
          [placeholder]="tk.User.Select | t"
          [controlName]="'operationStatus'"
          [options]="operationStatusOptions">
        </app-select>
      </div>

      <!-- Modalidades -->
      <div class="mt-4">
        <app-select
          [label]="'Modalidades'"
          [placeholder]="'Selecione as modalidades'"
          [controlName]="'operationStrategyTypes'"
          [options]="operationStrategyTypeOptions"
          [multiple]="true">
        </app-select>
      </div>

      <!-- Parcelas Vinculadas -->
      <div class="mt-4">
        <app-select
          [allowEmptyPlaceholderSelect]="true"
          [label]="'Parcelas Vinculadas'"
          [placeholder]="tk.User.Select | t"
          [controlName]="'withoutInstallments'"
          [options]="installmentsOptions">
        </app-select>
      </div>

      <!-- Status Financeiro -->
      <div class="mt-4">
        <app-select
          [allowEmptyPlaceholderSelect]="true"
          [label]="tk.Management.NdfFinancialStatus | t"
          [placeholder]="tk.User.Select | t"
          [controlName]="'financialStatus'"
          [options]="financialStatusOptions">
        </app-select>
      </div>

      <!-- Composição -->
      <div class="mt-4">
        <app-select
          [allowEmptyPlaceholderSelect]="true"
          [label]="tk.Management.NdfComposition | t"
          [placeholder]="tk.User.Select | t"
          [controlName]="'composition'"
          [options]="compositionOptions">
        </app-select>
      </div>

      <!-- Valor ME -->
      <div class="mt-4">
        <label class="field-group-label">{{ tk.Management.NdfValue | t }}</label>
        <div class="field-group">
          <div class="field-half">
            <app-input
              [label]="'De'"
              [placeholder]="'Valor mínimo'"
              [controlName]="'valueMEFrom'"
              [type]="'number'">
            </app-input>
          </div>
          <div class="field-half">
            <app-input
              [label]="'Até'"
              [placeholder]="'Valor máximo'"
              [controlName]="'valueMETo'"
              [type]="'number'">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Dias Corridos -->
      <div class="mt-4">
        <label class="field-group-label">{{ tk.Management.NdfCalendarDays | t }}</label>
        <div class="field-group">
          <div class="field-half">
            <app-input
              [label]="'De'"
              [placeholder]="'Dias mínimo'"
              [controlName]="'daysCountFrom'"
              [type]="'number'">
            </app-input>
          </div>
          <div class="field-half">
            <app-input
              [label]="'Até'"
              [placeholder]="'Dias máximo'"
              [controlName]="'daysCountTo'"
              [type]="'number'">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Valor Nocional -->
      <div class="mt-4">
        <label class="field-group-label">{{ tk.Management.NdfNotional | t }}</label>
        <div class="field-group">
          <div class="field-half">
            <app-input
              [label]="'De'"
              [placeholder]="'Valor mínimo'"
              [controlName]="'notionalAmountFrom'"
              [type]="'number'">
            </app-input>
          </div>
          <div class="field-half">
            <app-input
              [label]="'Até'"
              [placeholder]="'Valor máximo'"
              [controlName]="'notionalAmountTo'"
              [type]="'number'">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Forward Rate -->
      <div class="mt-4">
        <label class="field-group-label">{{ tk.Management.NdfForward | t }}</label>
        <div class="field-group">
          <div class="field-half">
            <app-input
              [label]="'De'"
              [placeholder]="'Taxa mínima'"
              [controlName]="'forwardRateFrom'"
              [type]="'number'">
            </app-input>
          </div>
          <div class="field-half">
            <app-input
              [label]="'Até'"
              [placeholder]="'Taxa máxima'"
              [controlName]="'forwardRateTo'"
              [type]="'number'">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Cap Value -->
      <div class="mt-4">
        <label class="field-group-label">{{ tk.Management.NdfCap | t }}</label>
        <div class="field-group">
          <div class="field-half">
            <app-input
              [label]="'De'"
              [placeholder]="'Valor mínimo'"
              [controlName]="'capValueFrom'"
              [type]="'number'">
            </app-input>
          </div>
          <div class="field-half">
            <app-input
              [label]="'Até'"
              [placeholder]="'Valor máximo'"
              [controlName]="'capValueTo'"
              [type]="'number'">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Reference Exchange Rate -->
      <div class="mt-4">
        <label class="field-group-label">{{ tk.Management.NdfReferenceExchange | t }}</label>
        <div class="field-group">
          <div class="field-half">
            <app-input
              [label]="'De'"
              [placeholder]="'Taxa mínima'"
              [controlName]="'referenceExchangeRateFrom'"
              [type]="'number'">
            </app-input>
          </div>
          <div class="field-half">
            <app-input
              [label]="'Até'"
              [placeholder]="'Taxa máxima'"
              [controlName]="'referenceExchangeRateTo'"
              [type]="'number'">
            </app-input>
          </div>
        </div>
      </div>

      <!-- Data de Vencimento -->
      <div class="mt-4">
        <label class="field-group-label">{{ tk.Management.NdfDueDate | t }}</label>
        <div class="field-group">
          <div class="field-half">
            <app-calendar
              [label]="(tk.Management.NdfDueDateInitial | t) || ''"
              [placeholder]="'Data inicial'"
              [controlName]="'dueAtFrom'"
              [selectionMode]="'single'"
              [useMask]="true" />
          </div>
          <div class="field-half">
            <app-calendar
              [label]="(tk.Management.NdfDueDateFinal | t) || ''"
              [placeholder]="'Data final'"
              [controlName]="'dueAtTo'"
              [selectionMode]="'single'"
              [useMask]="true" />
          </div>
        </div>
      </div>

      <!-- Data de Operação -->
      <div class="mt-4">
        <label class="field-group-label">{{ tk.Management.NdfDateOfOperation | t }}</label>
        <div class="field-group">
          <div class="field-half">
            <app-calendar
              [label]="tk.Management.OperationStartDate | t"
              [placeholder]="'Data inicial'"
              [controlName]="'operationDateFrom'"
              [selectionMode]="'single'"
              [useMask]="true" />
          </div>
          <div class="field-half">
            <app-calendar
              [label]="tk.Management.OperationEndDate | t"
              [placeholder]="'Data final'"
              [controlName]="'operationDateTo'"
              [selectionMode]="'single'"
              [useMask]="true" />
          </div>
        </div>
      </div>

      <!-- Referência -->
      <div class="mt-4">
        <app-input
          [label]="tk.Management.NdfReference | t"
          [placeholder]="tk.General.Insert | t"
          [controlName]="'remarks'">
        </app-input>
      </div>
    </div>

    <div class="filter-actions d-flex justify-content-between align-items-center">
      <app-button
        [label]="tk.General.Clear | t"
        type="button"
        (sendButtonClick)="clear()"
        theme="white" />
      <app-button [label]="tk.General.Apply | t" type="button" (sendButtonClick)="submit()" />
    </div>
  </form>
</p-drawer>
